import React from "react";
import "../PdfViewer.css"; // reuse same CSS

const WorksheetViewer = () => {
  const worksheetFiles = [
    {
      id: 1,
      title: "Worksheet 1",
      desc: "Worksheets focused on Polynomials (Class IX – TNSB)",
      url: "https://flippedlearning.neinus.com/pdf/Worksheet 1.pdf",
    },
    {
      id: 2,
      title: "Worksheet 2",
      desc: "Worksheets focused on Remainder Theorem.",
      url: "https://flippedlearning.neinus.com/pdf/Worksheet 2.pdf",
    },
    {
      id: 3,
      title: "Worksheet 3",
      desc: "Worksheets focused on Algebraic Identities.",
      url: "https://flippedlearning.neinus.com/pdf/Worksheet 3.pdf",
    },
    {
      id: 4,
      title: "Worksheets focused on Worksheet 4",
      desc: "Factorisation",
      url: "https://flippedlearning.neinus.com/pdf/Worksheet 4.pdf",
    },
    {
      id: 5,
      title: "Worksheet 5",
      desc: "Worksheets focused on Division of Polynomials",
      url: "https://flippedlearning.neinus.com/pdf/Worksheet 5.pdf",
    },
    {
      id: 6,
      title: "Worksheet 6",
      desc: "Worksheets focused on Greatest Common Divisor (GCD)",
      url: "https://flippedlearning.neinus.com/pdf/Worksheet 6.pdf",
    },
    {
      id: 7,
      title: "Worksheet 7",
      desc: "Worksheets focused on Linear Equations in Two Variables",
      url: "https://flippedlearning.neinus.com/pdf/Worksheet 7.pdf",
    },
  ];

  return (
    <section className="pdf-section">
      <h3>Practice Worksheets</h3>
      <div className="pdf-grid">
        {worksheetFiles.map((ws) => (
          <div key={ws.id} className="pdf-card">
            <div className="pdf-info">
              <h3>{ws.title}</h3>
              <p>{ws.desc}</p>
            </div>
            <div className="pdf-actions">
              <button
                onClick={() => window.open(ws.url, "_blank")}
                className="view-btn"
              >
                View
              </button>
              <a href={ws.url} download className="download-btn">
                Download
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WorksheetViewer;
